import { eventSender } from 'Lib/event-sender/event-sender';
import { onScreen } from 'Lib/on-screen/on-screen';
import { formatPrice } from 'Lib/format-price/format-price';

const $body = $('body');

export function getObjDetailBook() {
    const elBookPage = document.querySelector('.book-page');

    if (elBookPage) {
        const id = elBookPage.getAttribute('data-book-id');
        const brand = elBookPage.getAttribute('data-book-brand');
        const bookIdGuid = elBookPage.getAttribute('data-dmp-book-guid');
        const tabActive = elBookPage.querySelector('.prices-card__tab_active');
        const name = elBookPage.querySelector('.book-page__card-title')?.textContent.trim().replace('Электронная книга ', '').replace('Аудиокнига ', '').replace(/['"«»]/g, '');
        const bookPicture = document.querySelector('.book-page__cover-pic')?.getAttribute('src');
        const price = Number(formatPrice(elBookPage.querySelector('.price-insert__price')?.textContent));
        const oldPrice = Number(formatPrice(elBookPage.querySelector('.price-insert__old-price')?.textContent));
        const discountPrice = oldPrice && price ? oldPrice - price : null;
        const elBtnBasket = elBookPage.querySelector('.price-insert__btn');
        const isPreorder = elBtnBasket.querySelector('.btn__text')?.textContent.trim() === 'Предзаказ';
        const elBtnBasketAttr = elBtnBasket.getAttribute('data-book24-widget-basket-button-title');
        const textBtnBasket = elBtnBasketAttr || elBtnBasket.getAttribute('data-book24-widget-order-button-title') || elBtnBasket?.textContent.trim();
        let typeShort = '';
        let type;

        if (tabActive?.classList.contains('prices-card__tab_paper')) {
            typeShort = 'p';
            type = 'Бумажная';
            eventSender.customDL({ 'event': 'viewPbook', 'eventCategory': 'interaction', 'eventAction': 'viewing', 'eventLabel': 'paperBook', 'eventNonInteraction': 'true', 'firingOptions': 'string' });
        } else if (tabActive?.classList.contains('prices-card__tab_el')) {
            typeShort = 'e';
            type = 'Электронная';
            eventSender.customDL({ 'event': 'viewEbook', 'eventCategory': 'interaction', 'eventAction': 'viewing', 'eventLabel': 'eBook', 'eventNonInteraction': 'true', 'firingOptions': 'string' });
        } else {
            // eslint-disable-next-line no-unused-vars
            typeShort = 'a';
            type = 'Аудиокнига';
            eventSender.customDL({ 'event': 'viewAbook', 'eventCategory': 'interaction', 'eventAction': 'viewing', 'eventLabel': 'aBook', 'eventNonInteraction': 'true', 'firingOptions': 'string' });
        }

        return {
            'idGuid': bookIdGuid,
            price,
            name,
            id,
            discountPrice,
            oldPrice,
            brand,
            isPreorder,
            textBtnBasket,
            'picture': bookPicture,
            'firstCategory': elBookPage?.getAttribute('data-book-first-name-category'),
            'lastCategory': elBookPage?.getAttribute('data-book-last-name-category'),
            'author': elBookPage?.querySelector('.book-page__card-author')?.textContent.trim(),
            type,
            typeShort,
            'typeWishList': null,
        };
    }

    return null;
}

function obClickBuy() {
    const $this = $(this);

    if ($this.closest('.prices-card').find('.prices-card__tab_el').hasClass('prices-card__tab_active')) {
        eventSender.customDL({ 'event': 'buyLitres', 'eventCategory': 'ecommerce', 'eventAction': 'click', 'eventLabel': 'eBook', 'eventStatus': 'success', 'eventNonInteraction': 'false', 'firingOptions': 'oncePerEvent' });
    } else {
        eventSender.customDL({ 'event': 'buyLitres', 'eventCategory': 'ecommerce', 'eventAction': 'click', 'eventLabel': 'aBook', 'eventStatus': 'success', 'eventNonInteraction': 'false', 'firingOptions': 'oncePerEvent' });
    }
}

function sendDLSlider($el, viewEvent, clickEvent) {
    onScreen($el, () => {
        eventSender.customDL({ 'event': viewEvent, 'eventCategory': 'interaction', 'eventAction': 'viewing', 'eventLabel': viewEvent, 'eventNonInteraction': 'true', 'firingOptions': 'oncePerEvent' });
    });

    $el.find('.book__link').on('click', function () {
        const $th = $(this);
        const bookName = $th.find('.book__name').text();
        const nomcode = $th.closest('.books__item').attr('data-id');

        eventSender.customDL({ 'event': clickEvent, 'eventCategory': 'interaction', 'eventAction': 'click', 'eventLabel': `книга: ${bookName}, nomcode: ${nomcode}`, 'eventNonInteraction': 'false', 'firingOptions': 'oncePerEvent' });
    });
}

const objDetailBook = getObjDetailBook();

sendDLSlider($('.book-page__section-block_other-book-author'), 'viewOtherAuthor', 'clickOtherAuthor'); // Отправка аналитики в блоке "Другие книги автора"
sendDLSlider($('.book-page__section-block_similar-book'), 'viewLikeBook', 'clickLikeBook'); // Похожие книги

$body.on('likeTo.eksmo', (e, $el) => {
    if ($el.closest('.book-page__card').length) {
        objDetailBook.typeWishList = 'Добавить в избранное';
        eventSender.setWishListGA4(objDetailBook);
    }
});

$body.on('likeToCancel.eksmo', (e, $el) => {
    if ($el.closest('.book-page__card').length) {
        objDetailBook.typeWishList = 'Удалить из избранного';
        eventSender.removeWishList(objDetailBook);
    }
});

$body.on('addBookCollections.eksmo', () => {
    objDetailBook.typeWishList = 'Добавить в подборку';
    eventSender.setWishListGA4(objDetailBook);
});

$body.on('click', '.reader__btn-download', () => {
    objDetailBook.typeWishList = 'Скачать отрывок';
    eventSender.setWishListGA4(objDetailBook);
});

$body.on('click', '.book-page__link-to-reader', () => {
    eventSender.customDL({
        event: 'eksmo',
        eventAction: 'book_card',
        eventCategory: 'Читать фрагмент',
        eventLabel: objDetailBook.name,
    });
});

$body.on('audioPlay.eksmo', () => {
    eventSender.customDL({
        event: 'eksmo',
        eventAction: 'book_card',
        eventCategory: 'Слушать фрагмент',
        eventLabel: objDetailBook.name,
    });
});

/* События по клику на кнопку "В корзину"/"На Литрес"
Скрываем до появления новой ЧГ корзины
$body.on('addBookBasket.eksmo', (e, data) => {
    const elCurrAddedBook = document.querySelector(`.price-insert__btn[data-book24-widget="${data.productId}"]`);

    if (elCurrAddedBook) {
        eventSender.addGA4(objDetailBook);
    }
});
*/

$body.on('click', '.book-page__card .price-insert__btn:not(.btn_b24), .book-page__card .reader__btn-outer', function () {
    const $th = $(this);
    const link = $th.attr('href');
    const elTabActive = document.querySelector('.prices-card__tab_active') || document.querySelector('.tabs__link_active.prices-card__tab');

    if ($th.hasClass('price-insert__btn-subscription')) {
        objDetailBook.textBtnBasket = 'Купить по абонементу';
    }

    if (elTabActive?.classList.contains('prices-card__tab_el')) {
        eventSender.clickYM('click_litres_ebook', link);
        objDetailBook.shop = 'litres_ebook';
    } else if (elTabActive?.classList.contains('prices-card__tab_audio')) {
        eventSender.clickYM('click_litres_audio', link);
        objDetailBook.shop = 'litres_audio';
    } else if (elTabActive?.classList.contains('prices-card__tab_paper')) {
        eventSender.clickYM('click_paper', link);
        objDetailBook.shop = 'chitajgorod';
    }

    eventSender.sendSellingSS(objDetailBook);
    eventSender.addGA4(objDetailBook);
});

$('.prices-card__tab').on('click', function () {
    const $th = $(this);

    if (!$th.hasClass('prices-card__tab_active')) {
        if ($th.hasClass('prices-card__tab_paper')) {
            eventSender.customDL({ 'event': 'clickPaper', 'eventCategory': 'interaction', 'eventAction': 'click', 'eventLabel': 'paperBook', 'eventStatus': 'success', 'eventNonInteraction': 'false', 'firingOptions': 'oncePerEvent' });
        } else if ($th.hasClass('prices-card__tab_el')) {
            eventSender.customDL({ 'event': 'clickEbook', 'eventCategory': 'interaction', 'eventAction': 'click', 'eventLabel': 'eBook', 'eventStatus': 'success', 'eventNonInteraction': 'false', 'firingOptions': 'oncePerEvent' });
        } else {
            eventSender.customDL({ 'event': 'clickAbook', 'eventCategory': 'interaction', 'eventAction': 'click', 'eventLabel': 'aBook', 'eventStatus': 'success', 'eventNonInteraction': 'false', 'firingOptions': 'oncePerEvent' });
        }
    }
});

$('.prices-card__where-buy-item').on('click', function () {
    const $th = $(this);

    objDetailBook.shop = $th.attr('data-ym').replace('click_', '');
    eventSender.clickYM($th.attr('data-ym'), $th.attr('href'));
    eventSender.sendSellingSS(objDetailBook);
});

$('.book-page').first().find('.price-insert__btn').on('click', obClickBuy);
$(document).on('click', '.reader .price-insert__btn', obClickBuy);

document.addEventListener('DOMContentLoaded', () => {
    eventSender.viewBookDetailSS(objDetailBook);
});

eventSender.detailGA4(objDetailBook);